import { Box, Grid } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";
import { Helmet } from "react-helmet-async";
import CustomMissionVision from "../components/CustomMissionVision";
import CustomPrinciples from "../components/CustomPrinciples";

const VisionMission = () => {
  return (
    <>
      <Helmet>
        <title>Misión y Visión | Centro Médico MEDAM</title>
        <meta
          name="description"
          content="Conoce la misión, visión y valores del Centro Médico MEDAM. Brindamos atención médica profesional con calidad, tecnología, cercanía y empatía."
        />
        <meta
          name="keywords"
          content="Centro Médico MEDAM, misión MEDAM, visión MEDAM, valores médicos, atención médica Texcoco"
        />
        <meta
          property="og:title"
          content="Misión y Visión | Centro Médico MEDAM"
        />
        <meta
          property="og:description"
          content="En MEDAM trabajamos para ofrecer atención médica de calidad, con tecnología avanzada y un trato humano hacia nuestros pacientes."
        />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Box sx={design.header}>
        <CustomText
          variant="subtitle1"
          fontFamily="Nunito"
          color="#FFFFFF"
          fontWeight={800}
          text="Un equipo que cuida tu salud"
          sx={design.Titulo}
        >
          Un equipo que cuida tu salud
          <br />y la de tu familia
        </CustomText>
      </Box>
      <Grid container>
        <Grid size={design.Grid1} />
        <Grid container size={design.Grid10} sx={design.Cuida}>
          <CustomText
            color="#782A9F"
            fontWeight={700}
            fontFamily="Nunito"
            textAlign="left"
            width="100%"
            sx={design.TextNuestro}
          >
            NUESTRO PROPÓSITO
          </CustomText>
          <CustomText
            color="#00000"
            fontWeight={800}
            fontFamily="Nunito"
            textAlign="left"
            width="100%"
            sx={design.TextCuida}
          >
            Cuidarte y acompañarte en cada paso de tu bienestar
            <Box sx={design.Line} />
          </CustomText>
          <Grid container size={design.Grid6} sx={design.AlignText}>
            <CustomText
              color="#00000"
              fontWeight={500}
              fontFamily="Nunito"
              textAlign="left"
              width="100%"
              sx={design.TextCada}
            >
              Cada consulta y cada servicio están diseñados para ofrecer una
              <Box component="br" sx={design.br} />
              experiencia médica profesional, sin perder el toque humano que nos
              define.
            </CustomText>
            <CustomText
              color="#00000"
              fontWeight={500}
              fontFamily="Nunito"
              textAlign={{ xs: "left", md: "right" }}
              width="100%"
              sx={design.TextCentro}
            >
              Nos enorgullece ser un centro médico que ofrece atención cercana y
              <Box component="br" sx={design.br} />
              de calidad a nuestros pacientes.
            </CustomText>
          </Grid>
          <Grid container size={design.Grid6}>
            <ImageLoader
              src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Doctores_Medam.png"
              alt="servicios_a_domicilio_con_el_centro_medico_MEDAM"
              width={{ xs: "100%", md: "100%", xl: "95%" }}
              height={{ xs: "100%", md: "100%", xl: 424 }}
              borderRadius="20px"
            />
          </Grid>
        </Grid>
        <Grid size={design.Grid1} />
      </Grid>
      <CustomMissionVision />

      <CustomPrinciples />
    </>
  );
};

export default VisionMission;

const design = {
  header: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/Recepcion_renders_medam.png)`,
    backgroundPosition: "100%",
    height: { xs: "40vh", md: "70vh" },
    backgroundSize: "130%",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    alignContent: "center",
    flexDirection: "column",
  },
  Titulo: {
    fontSize: { xs: 28, sm: 36, md: 50, lg: 50 },
    lineHeight: "normal",
    paddingBottom: { xs: "10%", md: "5%" },
    paddingLeft: { xs: "0.3%", md: "0%" },
  },
  Cuida: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    pt: 5,
    pb: 5,
  },
  br: {
    display: { xs: "none", md: "block" },
  },
  TextNuestro: {
    letterSpacing: "2px",
    textTransform: "uppercase",
    fontSize: { xs: 13, md: 14 },
    mb: 3,
  },
  TextCuida: {
    fontSize: { xs: 42, sm: 52, md: 30, lg: 30 },
    mb: 1,
    lineHeight: "normal",
  },
  Line: {
    width: 100,
    height: 6,
    borderRadius: 50,
    background: "#162E84",
  },
  AlignText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    rowGap: { xs: 1, md: 16 },
    pr: 2,
  },
  TextCada: {
    fontSize: { xs: 18, sm: 18, md: 18, lg: 18 },
    mb: 1,
  },
  TextCentro: {
    fontSize: { xs: 18, sm: 18, md: 18, lg: 20 },
    mb: 1,
  },
  Grid1: { xs: 0.5, md: 1, xl: 1, lg: 1 },
  Grid10: { xs: 11, md: 10, xl: 10, lg: 10 },
  Grid6: { xs: 12, md: 6, xl: 6, lg: 6 },
};
